import routes from "@/config/routes.js";
import menu from "@/config/menu.js";
import themes from "@/config/themes.js";

export default {
	routes: routes,
	menu: menu,
	theme: themes,
}

/*
	You also need to:
	- Customize SCSS in:
		- scss/app.scss
		- scss/variables.scss
	- Change logo in assets/logo.png or svg
*/
